import { Gateway } from '../../../../shared/api/gateway/Gateway';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';
import { PutVehicleRequest } from '../../../../shared/api/gateway/types/vehicle';

export type ILoaderEditVehicle = (args: PutVehicleRequest) => Promise<IVehicle>;

export function editVehicleLoader(api: Gateway): ILoaderEditVehicle {
	return async ([vehicleId, data]) => {
		const vehicle = await api.vehicle().editVehicle(vehicleId, data);
		return vehicle;
	};
}
